export default __webpack_public_path__ + "static/media/boxilogof.ad5eba37.png";